import PropTypes from 'prop-types';
import React from 'react';

import styles from './firmware-update-dialog.css';

// Flashing popup, laid out like plode-web's DialogModal.
// `buttons` empty = busy: top notification with spinner, text and progress bar.
// Otherwise a result modal (same card as the firmware dialog) with actions.
const FirmwareFlashDialog = ({ buttons, progress, text }) => (buttons.length === 0 ? (
    <div className={styles.flashNotice}>
        <div className={styles.flashBox}>
            <div className={styles.dotSpinner}>
                <div />
                <div />
                <div />
            </div>
            <div className={styles.flashWrapper}>
                <div className={styles.flashText}>{text}</div>
                {typeof progress === 'number' && (
                    <div className={styles.progressTrack}>
                        <div
                            className={styles.progressBar}
                            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
                        />
                    </div>
                )}
            </div>
        </div>
    </div>
) : (
    <div className={styles.overlay}>
        <div className={styles.modal}>
            <div className={styles.content}>
                <div className={styles.deviceInfo}>
                    <p className={styles.statusText}>{text}</p>
                </div>
                <div className={styles.actions}>
                    {buttons.map((button, i) => (
                        <button
                            className={i === 0 ? styles.updateButton : styles.skipButton}
                            key={button.text}
                            onClick={button.onClick}
                        >
                            {button.text}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    </div>
));

FirmwareFlashDialog.defaultProps = {
    buttons: [],
};

FirmwareFlashDialog.propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired,
    })),
    progress: PropTypes.number,
    text: PropTypes.string.isRequired,
};

export default FirmwareFlashDialog;
